import { Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CardHeader } from "@/components/ui/card";

interface BusinessProfileHeaderProps {
  isEditing: boolean;
  onEditToggle: () => void;
}

const BusinessProfileHeader = ({ isEditing, onEditToggle }: BusinessProfileHeaderProps) => {
  return (
    <CardHeader className="flex flex-col sm:flex-row items-start sm:items-center justify-between space-y-2 sm:space-y-0 pb-4 bg-gradient-to-r from-purple-50 to-white border-b border-purple-100/50">
      <div className="flex items-center space-x-3">
        <Building2 className="h-6 w-6 text-purple-600" />
        <h2 className="text-xl sm:text-2xl font-semibold bg-clip-text text-transparent bg-gradient-to-r from-purple-700 to-purple-900">
          Business Profile
        </h2>
      </div>
      <Button 
        onClick={onEditToggle}
        variant={isEditing ? "default" : "outline"}
        className={`w-full sm:w-auto transition-all duration-300 ${
          isEditing 
            ? 'bg-purple-600 hover:bg-purple-700 text-white shadow-lg hover:shadow-purple-200' 
            : 'hover:bg-purple-50 border-purple-200 text-purple-700'
        }`}
      >
        {isEditing ? "Save Profile" : "Edit Profile"}
      </Button>
    </CardHeader>
  );
};

export default BusinessProfileHeader;